import { AppColors } from "@/styles/colors";
import { Box, Button, Dialog, Flex, Portal, Text } from "@chakra-ui/react";
import type { TaxUploadHistoryItem } from "@/pages/config/taxes/schema/taxes.schema";
import { LightMode } from "@/components/ui/color-mode";
import dayjs from "dayjs";

interface Props {
  open: boolean;
  setOpen: (flag: boolean) => void;
  selectedForDetail: TaxUploadHistoryItem | null;
}

export const TaxesErrorsModal = ({
  open,
  setOpen,
  selectedForDetail,
}: Props) => {
  return (
    <Dialog.Root
      placement="center"
      lazyMount
      open={open}
      onOpenChange={(e) => setOpen(e.open)}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <LightMode>
            <Dialog.Content
              bgColor={AppColors.WHITE_SECONDARY}
              color={AppColors.BLACK_TEXT_SECONDARY}
            >
              <Dialog.Header paddingY="16px" paddingLeft="24px">
                <Dialog.Title fontWeight={600} fontSize="18px">
                  Detalle de errores 
                  <Text color={AppColors.GRAY_TEXT_ALT} fontStyle="italic" fontWeight={600} fontSize="14px">
                    {dayjs(selectedForDetail?.fechaCarga).format("DD/MM/YYYY HH:mm")}
                  </Text>
                </Dialog.Title>
              </Dialog.Header>
              <Dialog.Body paddingX="24px" paddingY="8px">

                {selectedForDetail?.errores?.length ? (
                  <Flex
                    flexDir="column"
                    gap="8px"
                    maxHeight="400px"
                    overflowY="auto"
                  >
                    {selectedForDetail.errores.map((err) => (
                      <Box
                        key={`${selectedForDetail.id}-${err.numeroFila}-${err.detalle}`}
                        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
                        borderRadius="8px"
                        px="12px"
                        py="10px"
                      >
                        <Text fontWeight={700}>Fila {err.numeroFila}</Text>
                        <Text color={AppColors.GRAY_TEXT}>{err.detalle}</Text>
                      
                      </Box>
                    ))}
                  </Flex>
                ) : (
                  <Text color={AppColors.GRAY_TEXT}>Sin errores</Text>
                )}
              </Dialog.Body>
              <Dialog.Footer paddingY="16px" paddingX="24px">
                <Dialog.ActionTrigger asChild>
                  <Button
                    bgColor={AppColors.BLACK_TEXT_SECONDARY}
                    paddingX="16px"
                    fontWeight={600}
                  >
                    <Text color={AppColors.WHITE_SECONDARY}>Cerrar</Text>
                  </Button>
                </Dialog.ActionTrigger>
              </Dialog.Footer>
            </Dialog.Content>
          </LightMode>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
